import includes from 'lodash/includes';

export const validateDomain = (
  validDomains: (string | null | undefined)[] | undefined,
  email: string,
  isPartnerAccount: boolean | undefined
) => {
  const domain = email.split('@')[1];

  if (isPartnerAccount && !includes(validDomains, domain)) {
    return false;
  }
  return true;
};
